export default __webpack_public_path__ + "static/media/men.21a916e4.jpg";